<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат Mobile Maxi Scroller</div>
    <div class="markup__h markup__h_3">
      Данное размещение может содержать картинки, текст, видео.
    </div>
    <br>
    <router-link to="/mobile/maxiScroller" target="_blank" class="link">Демо формата</router-link>
    <br><br>

    <div class="markup__h markup__h_2">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Фон:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PSD / FIGMA / AI </li>
          <li>Соотношение сторон: рекомендуется 9:16</li>
          <li>
            <p>Размеры: рекомендуется от <strong>1080px : 1920px</strong></p>
            <div class="attention attention_warn">
              <p>При подготовке материалов необходимо учесть вариант отображения в горизонтальном режиме (landscape). В другом случае будет добавлено брендированное сообщение "Поверните ваш девайс вертикально".</p>
              <p>Также необходимо учитывать, что формат адаптивный как по ширине так и по высоте, т.к. объявление может показываться на устройствах с различными размерами экрана (смартфоны / планшеты).</p>
            </div>
          </li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Опционально</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Сценарий (последовательность анимации, смены слайдов и т.д.)</li>
          <li>Описание интерактивных элементов (кликабельные элементы, кнопки и т.д.)</li>
          <li>При отсутствии макетов для сборки креатива необходимо предоставить тексты и изображения (PNG / JPG / PDF / EPS), логотип, фирменные шрифты, Brandbook (в том числе пожелания по цветовому оформлению)</li>
          <li>
            <strong>Видеоролик:</strong>
            <ul class="markup__ul markup__ul_nested">
              <li>Ссылка на ролик на YouTube или видео-файл</li>
              <li>Формат: MP4, MOV</li>
              <li>Видеокодек: H.264</li>
              <li>Аудиокодек: MP3 или AAC</li>
              <li>Разрешение: рекомендуется не ниже Full HD 1080p</li>
              <li>Частота кадров: 30 в секунду</li>
              <li>Вес: рекомендуется до 3 МБ</li>
              <li>Хронометраж: до 15 секунд</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <br>
    <div class="html2pdf__page-break"/>
    <br>
    <div class="markup__h markup__h_3">
      <strong>Предусмотрено несколько вариантов верстки формата с роликом (на выбор):</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Вертикальный ролик</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Соотношение сторон: 9:16 (например, <strong>1080px : 1920px</strong>)</li>
          <li>Данный вариант предусматривает наличие небольших полей сверху и снизу / справа и слева по краям ролика. Это происходит по причине того, что ролик не стремится занять все доступное пространство по ширине, а занимает доступную площадь креатива, не меняя соотношение своих сторон, таким образом, чтобы и по ширине, и по высоте он помещался в каждом отдельном девайсе, а соотношение сторон у разных устройств отличается.</li>
          <li>Поля можно обыграть фоновым цветом, изменяя его в зависимости от цветовой гаммы внутри ролика, либо же пожелания клиента. Данные поля небольшие - не рекомендуется располагать на них какие-то дополнительные элементы в виде картинок или текста.</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Квадратный ролик</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Соотношение сторон: 1:1 (например, <strong>1080px : 1080px</strong>)</li>
          <li>Данный вариант размещения предполагает заметные поля, занимающие примерно 1/2 креатива.</li>
          <li>Допустимо выбрать расположение ролика - сверху / по центру / снизу креатива. В данном случае ролик занимает все доступное пространство по ширине креатива.</li>
          <li>Для брендирования полей необходимо предоставить исходные материалы, согласно ТТ. Могут быть расположены изображения, тексты/слоганы, логотипы и прочие элементы.</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Горизонтальный ролик</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Соотношение сторон: 16:9 (например, <strong>1920px : 1080px</strong>)</li>
          <li>Данный вариант размещения предполагает заметные поля, занимающие примерно 1/3 креатива.</li>
          <li>Допустимо выбрать расположение ролика - сверху / по центру / снизу креатива. В данном случае ролик занимает все доступное пространство по ширине креатива.</li>
          <li>Для брендирования полей необходимо предоставить исходные материалы, согласно ТТ. Могут быть расположены изображения, тексты/слоганы, логотипы и прочие элементы.</li>
        </ul>
      </li>
    </ul>
    <br>
    <marked-zone-atention></marked-zone-atention>

  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'mobileMaxiScroller',
  components: {
    markedZoneAtention,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
